import React, { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import { useNavigate, Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { 
  Power, 
  QrCodeScan, 
  Speedometer2, 
  PeopleFill, 
  DoorClosed, 
  PersonCheck, 
  Gear, 
  ListCheck,
  BoxArrowInRight,
  PersonPlus,
  Settings,
  BagCheck
} from "react-bootstrap-icons";
import './Dashboard.css';
import Header from './components/Header';
import Footer from './components/Footer';
const Dashboard = () => {
  const [user, loading, error] = useAuthState(auth);
  const [hotellist, setHotellist] = useState([]);
  const [users, setUsers] = useState([]);
  const [nousers, setNoUsers] = useState(0);
  const [clubs, setClubs] = useState([]);
  
  let tmpCounter = "";
  if (localStorage.getItem("Counter")) {
    tmpCounter = localStorage.getItem("Counter");
  }
  const [Counter, setSelectedOption] = useState(tmpCounter);
  const [msg, setMessage] = useState("");

   
  const handleChange = (event) => {
    setSelectedOption(event.target.value);
       
  };
 
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
  
  }, [user, loading]);

  
  const navigate = useNavigate();

  return (
    <div className="dashboard-container" style={{ color: '#f8f9fa', minHeight: '100vh' }}>
      {/* Header */}
      <Header 
     
     showBack={false}
     showDashboard={true}
     showSignOut ={true}
   />
   
    <span className="pe-4" align="right">{user.email}</span>
      {/* Main Content */}
      <main className="dashboard-main">
     
        
        {/* Dashboard Grid */}
        <div className="dashboard-grid">
          {/* QR Code Scanner */}
          <DashboardCard 
            icon={<QrCodeScan size={32} />}
            title="Scan QR Code"
            description="Scan attendee QR codes for check-in"
            onClick={() => navigate("/rmqrreader")}
            color="#e51743"
          />

          {/* Goodie Bag Scanner */}
          <DashboardCard 
            icon={<BagCheck size={32} />}
            title="Goodie Bag Scanner"
            description="Scan QR codes for goodie bag distribution"
            onClick={() => navigate("/goodiebagscanner")}
            color="#00bcd4"
          />

          {/* Manage Registrations */}
    {/*      <DashboardCard 
            icon={<PersonPlus size={32} />}
            title="Manage Registrations"
            description="View and manage event registrations"
            onClick={() => navigate("/masterDashboard")}
            color="#2e7d32" 
          />

          
          {/* Room Assignment */}
  {/*        <DashboardCard 
            icon={<DoorClosed size={32} />}
            title="Room Assignment"
            description="Assign and manage room allocations"
            onClick={() => navigate("/registration-report-2026")}
            color="#6a1b9a"
          />
*/}
          {/* Attendee Management */}
          <DashboardCard 
            icon={<PeopleFill size={32} />}
            title="Attendee Management"
            description="Manage attendee information and details"
            onClick={() => navigate("/controlroom")}
            color="#ff8f00"
          />

          {/* Schedule */}
     {/*       <DashboardCard 
            icon={<Gear size={32} />}
            title="Event Setting"
            description="View and manage event settings"
            onClick={() => navigate("/camp-settings")}
            color="#00838f"
          />

          {/* Live Tracking */}
      {/*     <DashboardCard 
            icon={<Speedometer2 size={32} />}
            title="Live Tracking"
            description="Monitor event in real-time"
            onClick={() => navigate("/livetracking")}
            color="#c2185b"
          />

          {/* Reports */}
     {/*       <DashboardCard 
            icon={<ListCheck size={32} />}
            title="Reports"
            description="Generate and view event reports"
            onClick={() => navigate("/reports")}
            color="#5d4037"
          />
    */}    </div>
      </main>

      <Footer />
    </div>
  );
};

// Dashboard Card Component
const DashboardCard = ({ icon, title, description, onClick, color }) => (
  <div className="dashboard-card" onClick={onClick} style={{ '--card-color': color }}>
    <div className="card-icon" style={{ backgroundColor: `${color}40` }}>
      {React.cloneElement(icon, { color: color })}
    </div>
    <h3 className="card-title">{title}</h3>
    <p className="card-description">{description}</p>
  </div>
);

export default Dashboard;
